import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

const TopicItem = ({ topic }) => {
  const content = useSelector((state) => state.cms.faq)
  return (
    <a
      className="faq-topic bg-white text-center rounded p-3 pb-4 d-block text-decoration-none"
      href={`#topic_${topic?.id}`}
    >
      <span className="topic-icon">
        <i className="material-icons">{topic?.icon}</i>
      </span>
      <span className="topic-title h5 d-block text-dark">{topic?.title}</span>
      <span className="topic-count font-sm text-muted d-flex align-items-center justify-content-center">
        {`${topic?.faqItems?.length || topic?.totalItems || 0} ${content.answers}`}
        <i className="material-icons ms-2 mt-1">trending_flat</i>
      </span>
    </a>
  )
}

TopicItem.propTypes = {
  topic: PropTypes.instanceOf(Object).isRequired
}

export default TopicItem
